module.exports = __webpack_public_path__ + "static/media/gold-silver-navigation-background.5d8c7077.jpeg";